import styled from "@emotion/styled";
import { useSelector } from "react-redux";

import { authSelector } from "../../redux/slices/authSlice";
import SidebarItem from "./SidebarItem";
import SidebarAccounts from "./SidebarAccounts";

import dash from "../../assets/chart.svg";
import details from "../../assets/clipboard.svg";

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;

const getSideData = (token) => [
  {
    id: 234,
    label: "Dashboard",
    url: "/",
    svg: dash,
  },
  ...(String(token || "").includes("Cloudbeds_Micros")
    ? [
        {
          id: 534,
          label: "Cloudbeds",
          url: "/cloudbedsoAuth2",
          svg: details,
        },
      ]
    : []),
  {
    id: 734,
    label: "Details",
    url: "/details",
    svg: details,
  },
];

const SidebarList = () => {
  const { token } = useSelector(authSelector);
  const sideData = getSideData(token);

  return (
    <Wrapper>
      {sideData.map((i) => (
        <SidebarItem key={i.id} item={i} />
      ))}
      <SidebarAccounts />
    </Wrapper>
  );
};

export default SidebarList;
